import React, { useState, useEffect } from 'react';
import '../../../Styles/ColoresCatalog.css';

export default function TipoLogosModal({ open, mode, data, onClose, onSubmit }) {
    const [form, setForm] = useState({
        nombre: '',
        activo: true
    });

    useEffect(() => {
        if (open) {
            if (mode === 'edit' && data) {
                setForm({
                    nombre: data.nombre || '',
                    activo: data.activo ?? true
                });
            } else {
                setForm({
                    nombre: '',
                    activo: true
                });
            }
        }
    }, [open, mode, data]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    if (!open) return null;

    const labelStyle = {
        display: 'block',
        fontSize: '0.95rem',
        fontWeight: '800',
        color: '#0f172a',
        marginBottom: '0.5rem'
    };

    const Header = (
        <div
            className="roles-topbar"
            style={{
                marginBottom: '1.5rem',
                paddingRight: 16,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flex: '0 0 auto',
            }}>
            <h3 className="roles-title" style={{ marginRight: 0 }}>
                {mode === 'new' ? 'Registrar Tipo de Logo' : 'Editar Tipo de Logo'}
            </h3>
            <button className="roles-btn" onClick={onClose} aria-label="Cerrar">
                ✕
            </button>
        </div>
    );

    const Body = (
        <div
            style={{
                paddingLeft: '2rem',
                paddingRight: '2rem',
                display: 'flex',
                flexDirection: 'column',
                gap: '1.5rem',
                overflowY: 'auto',
                flex: '1 1 auto',
                minHeight: 0,
            }}>

            <div>
                <label style={labelStyle}>Nombre del Tipo:</label>
                <input
                    className="infoField"
                    name="nombre"
                    value={form.nombre}
                    onChange={handleChange}
                    placeholder="Ej: Logo Principal, Icono, Favicon..."
                    autoFocus
                />
            </div>

        </div>
    );

    const Footer = (
        <div
            style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '.8rem',
                marginTop: '2rem',
                paddingRight: '2rem',
                flex: '0 0 auto',
            }}
        >
            <button className="roles-btn" onClick={onClose}>Cancelar</button>
            <button
                className="btn-action"
                onClick={() => onSubmit(form, mode)}
                disabled={!form.nombre}
                style={{
                    opacity: !form.nombre ? 0.5 : 1,
                    cursor: !form.nombre ? 'not-allowed' : 'pointer',
                }}
            >
                {mode === 'new' ? 'Guardar' : 'Actualizar'}
            </button>
        </div>
    );

    return (
        <div className="roles-inline-card" style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
            {Header}
            {Body}
            {Footer}
        </div>
    );
}
